module.exports = __webpack_public_path__ + "img/tower_mosaic.6a57fb46.jpg";